module.exports = __webpack_public_path__ + "media/images/about_icon-ce6bf2c4871a54f283cccb43e8735398.svg";